import { ApiFloor } from "avvir";

import { AvvirEvent } from "type_aliases";


export type FloorLoadedEvent = AvvirEvent<typeof FLOOR_LOADED, { floor: ApiFloor, projectName: string }>

const floorLoaded = (floor: ApiFloor): FloorLoadedEvent => ({
  type: FLOOR_LOADED,
  payload: {
    floor,
    projectName: null,
  }
});

export const FLOOR_LOADED = "floor_loaded";

export default floorLoaded;
